module.exports = __webpack_public_path__ + "img/guigui_skear.d1cdd1a5.jpg";